module.exports = __webpack_public_path__ + "static/media/standard.2e760550.jpg";